import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { DateNowExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateNowExpression";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import React from "react";

export class DateNowExpressionEditor extends ExpressionRuleEditor<DateNowExpression> {
    render() {
        return <ExpressionPiece> {"[Now]"} </ExpressionPiece>;
    }
}
